module.exports = {
      id: "vikatan-play-usage",
      viewBox: "0 0 27.8 28.8",
      url: "/" + "sprite-5d017f3fe034ec5d98a70bae909b913a.svg#vikatan-play",
      toString: function () {
        return this.url;
      }
    }